import {
  dashboard,
  userList,
  userMergeSuggestions,
  dataSharingRequests,
  benefits,
  gym,
  gymTeacherDashboard,
  schools,
  attendanceReport,
  findPhysicalSpaces,
  tickets,
  workouts,
  finances,
  calendar,
  associationTitles,
  healthInsuranceComparisonReport,
  lifeInsuranceComparisonReport,
  biometryEnroll,
  physicalSpaceReservations,
  physicalAccess,
  customReport,
  contracts,
  campaigns,
  spaceRenting,
  events,
  accountsPayablePage,
  accountsReceivablePage,
  contractsCrm,
  cancellationReport,
  tasksBoard,
  notificationAnalytics,
  analyticsDashboard,
  aiUsageDashboard,
  mcpUsageDashboard,
  benefitPointsDashboard,
  nutritionDiary,
  convenioCredencial,
  convenioUsageList,
  convenioManagement,
  convenioInsights,
} from 'app/views/routes'
import { surveyBuilderNavigation } from 'app/navigation/surveyBuilderNavigation'
import { USER_TYPE } from './ducks/auth/types'
import { TENANT_FLAG } from 'app/tenantFeatureFlags'
import { isRetentionModuleEnabled } from 'app/views/retention/hooks'
import { Store } from 'app/redux/Store'
import { getFeatureFlag } from 'app/ducks/featureFlags/selectors'
import { BENEFIT_POINTS_DASHBOARD_FLAG } from 'app/views/benefit-points/benefitPoints'
import { MCP_FLAG } from 'app/views/mcp/mcp'

// The menu entry for `benefitPointsDashboard`: unlike the route, hidden while
// the flags are still loading, so it never flashes in for a tenant without it
const benefitPointsDashboardNav = {
  ...benefitPointsDashboard,
  userCondition: () =>
    getFeatureFlag(Store.getState(), BENEFIT_POINTS_DASHBOARD_FLAG),
}

// Same for `mcpUsageDashboard`, whose route doesn't check the flag at all (the
// backend answers 404 when it's off, see app/views/mcp/mcp.js)
const mcpUsageDashboardNav = {
  ...mcpUsageDashboard,
  userCondition: () => getFeatureFlag(Store.getState(), MCP_FLAG),
}

export const navigations = [
  dashboard,
  {
    name: 'Administrativo',
    icon: 'admin_panel_settings',
    roles: [USER_TYPE.ADMINISTRATOR],
    featureFlag: TENANT_FLAG.ADMINISTRATION_NAVIGATION,
    children: [
      {
        name: 'Administração',
        path: `${process.env.REACT_APP_BACKEND_URL}/admin`,
        type: 'extLink',
        icon: 'admin_panel_settings',
        roles: [USER_TYPE.ADMINISTRATOR],
        featureFlag: TENANT_FLAG.DJANGO_ADMIN_LINK,
      },
      finances,
      accountsPayablePage,
      accountsReceivablePage,
      // physicalDeviceManagement,
      associationTitles,
      healthInsuranceComparisonReport,
      lifeInsuranceComparisonReport,
      userMergeSuggestions,
      dataSharingRequests,
      notificationAnalytics,
      analyticsDashboard,
      aiUsageDashboard,
      mcpUsageDashboardNav,
      benefitPointsDashboardNav,
    ],
  },
  userList,
  tasksBoard,
  {
    ...workouts,
    name: 'Treinos',
    roles: [USER_TYPE.TOTEM],
  },
  gym,
  gymTeacherDashboard,
  nutritionDiary,
  surveyBuilderNavigation,
  {
    name: 'Contratos',
    icon: 'article',
    roles: [USER_TYPE.ADMINISTRATOR],
    featureFlag: TENANT_FLAG.CONTRACTS_CRM,
    children: [
      contracts,
      contractsCrm,
      { ...cancellationReport, userCondition: isRetentionModuleEnabled },
    ],
  },
  campaigns,
  events,
  spaceRenting,
  schools,
  attendanceReport,
  biometryEnroll,
  tickets,
  physicalAccess,
  calendar,
  benefits,
  customReport,
  findPhysicalSpaces,
  physicalSpaceReservations,
  convenioCredencial,
  convenioUsageList,
  convenioManagement,
  convenioInsights,
]
